// ============================================================
// BLACK OWL - Spectator mode (FB-14)
// ============================================================
// Spectators watch a lobby read-only: they live in
// Lobbies/{id}/spectators, never in players, and every screen
// hides its Fire / Pay / draft controls for them.
// ============================================================

import { FONT_BODY } from "./theme";

export function SpectatingBadge({ style }) {
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: "6px",
      padding: "4px 10px", whiteSpace: "nowrap",
      fontSize: "10px", fontWeight: 700, letterSpacing: "1px",
      textTransform: "uppercase", fontFamily: FONT_BODY,
      color: "#4a9eff", background: "rgba(74, 158, 255, 0.12)",
      border: "1px solid rgba(74, 158, 255, 0.3)", borderRadius: "12px",
      flexShrink: 0,
      ...style,
    }}>👁 Spectating</span>
  );
}

// leave_lobby body: spectators only drop their spectators doc
export function leaveLobbyBody(username, lobbyId, isSpectator) {
  return isSpectator
    ? { username, lobby_id: lobbyId, role: "spectator" }
    : { username, lobby_id: lobbyId };
}
